import { CloseRounded } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tab, Tabs, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TabPanel from '../../../../shared/components/TabPanel'
import { CancelButton, SaveButton } from '../../../../shared/components/inputs'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { formsStyles } from '../../../../shared/styles/FormsStyles'
import { useSeminarLesson } from '../hooks/useSeminarLesson'
import { BasicInfoTab } from './lessonmodal/BasicInfoTab'
import { GeneralTab } from './lessonmodal/GeneralTab'
import { SupportMaterialTab } from './lessonmodal/SupportMaterialTab'

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

function SeminarLessonModal() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const theme = useTheme()
  const formClasses = formsStyles(theme)

  const {
    seminarLessonState,
    currentTab,
    seminarSelected,
    novelties,
    showForm,
    errorForm,
    errorTab,
    msgForm,
    isValidForm,
    handleInputChange,
    handleInputChange2,
    handleNotificationsChange,
    handleMultiAutoCompleteChange,
    handleDateTimeChange,
    handleTypeChange,
    handleContentChange,
    handleExtraContentChange,
    getUploadParams,
    handleSubmit,
    handleChangeTab,
    handleCloseForm
  } = useSeminarLesson()

  const dialogTitle = seminarLessonState.id !== null ? `${t('edit')} ${t('lesson')}` : `${t('create')} ${t('lesson')}`

  const saveButtonText = seminarLessonState.id !== null ? t('save') : t('create')

  return (
    <Dialog
      open={showForm}
      fullWidth={true}
      fullScreen={isMobile && true}
      maxWidth={!isMobile && 'md'}
      sx={formClasses.containerForm}
      onClose={handleCloseForm}
      aria-labelledby="form-dialog-title"
      disableEnforceFocus
    >
      <DialogTitle id="form-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">{dialogTitle}</Typography>
          <Button onClick={handleCloseForm} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>

      <DialogContent sx={formClasses.bodyForm}>
        <BasicInfoTab
          seminarLessonState={seminarLessonState}
          seminarSelected={seminarSelected}
          errorForm={errorForm}
          msgForm={msgForm}
          handleInputChange={handleInputChange}
        />

        <Grid item xs={12}>
          <Tabs
            value={currentTab}
            indicatorColor="secondary"
            textColor="primary"
            sx={formClasses.tapForm}
            onChange={handleChangeTab}
            aria-label="lesson form tabs"
          >
            <Tab label={t('general')} {...a11yProps(0)} sx={errorTab.general ? formClasses.errorTab : undefined} />
            <Tab label="Material de apoyo" {...a11yProps(1)} />
          </Tabs>
        </Grid>

        <TabPanel value={currentTab} index={0}>
          <GeneralTab
            seminarLessonState={seminarLessonState}
            errorForm={errorForm}
            msgForm={msgForm}
            handleInputChange={handleInputChange2}
            handleDateTimeChange={handleDateTimeChange}
            handleTypeChange={handleTypeChange}
            handleContentChange={handleContentChange}
            handleExtraContentChange={handleExtraContentChange}
            handleNotificationsChange={handleNotificationsChange}
          />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <SupportMaterialTab
            seminarLessonState={seminarLessonState}
            novelties={novelties}
            handleMultiAutoCompleteChange={handleMultiAutoCompleteChange}
            getUploadParams={getUploadParams}
          />
        </TabPanel>
      </DialogContent>

      <DialogActions sx={!isValidForm && Object.keys(msgForm).length > 0 ? formClasses.errorDialogActions : undefined}>
        <CancelButton onClick={handleCloseForm}>{t('cancel')}</CancelButton>
        <SaveButton data-createlesson="saveButton" onClick={handleSubmit}>
          {saveButtonText}
        </SaveButton>
      </DialogActions>
    </Dialog>
  )
}

export default SeminarLessonModal
